import React from "react";

function FirstStep() {
  return (
    <section className="bg-[#F7F3F2]">
      <div className="mx-auto w-full max-w-7xl px-5 py-16 md:px-10 md:py-20">
        <div className="flex flex-col items-center text-center">
        <div className="flex items-center rounded-md px-3 py-1">
            <p className="text-sm uppercase mb-12 text-black">FREE SEO REVIEW</p>
          </div>
          <h2 className="text-3xl font-regular md:text-5xl text-black max-w-2xl uppercase">
          Schedule Your <span className='italic text-black bg-[#CFF098]'>Free</span>
          </h2>
          <p className="mb-8 mt-4 max-w-lg text-base text-black md:mb-12 md:text-lg font-light">
          Let us analyze your website and SEO to identify opportunities for growth. See how a professional web design company can elevate your online presence.
          </p>
        </div>
        <div className="grid gap-5 sm:grid-cols-2 md:grid-cols-3 md:gap-4">
          <div className="grid gap-6 border border-solid border-black p-8 md:p-10">
            <h3 className="text-xl font-semibold text-black">SIMPLE & FREE CONSULTATION</h3>
            <p className="text-black text-lg mb-10 font-light">
            Once you fill our the form with some basic information, you’ll be sent directly to our Cal to book a 15-minute time slot convenient for you. We can also send the review by Loom to meet your busy schedule. This is your first step to hiring a web design expert.
            </p>
          </div>

          <div className="grid gap-6 border border-solid border-black p-8 md:p-10">
            <h3 className="text-xl font-semibold text-black">GET INSIGHTS ON YOUR ONLINE PERFORMANCE</h3>
            <p className="text-black text-lg mb-10 font-light">
            We’ll discuss your specific challenges and provide you clarity on the big-picture, so you walk away with actionable takeaways to implement immediately. Understand if you need to hire a website builder or other services.
            </p>
          </div>
          <div className="grid gap-6 border border-solid border-black p-8 md:p-10">
            <h3 className="text-xl font-semibold text-black">RECEIVE A CUSTOMIZED GROWTH PLAN</h3>
            <p className="text-black text-lg mb-10 font-light">
            We'll provide actionable recommendations to improve your website's visibility and attract more clients. This will help you decide if you need to hire web designers.
            </p>
          </div>
        </div>
        <div className="flex flex-col items-center justify-center mt-10">
        <a href="https://cal.com/woaomwebdesign/15min"
  target="_blank"
  rel="noopener noreferrer">
  <button className="text-black bg-[#CFF098] rounded-full px-6 py-2 border-[1px] border-black">BOOK YOUR FREE REVIEW →</button>
  </a>
  <p className="text-black text-lg font-light mt-6 w-[400px] text-center">No prep needed! Just come talk & we’ll figure it out together. Let's see if we're the right fit when you're ready to hire web designer.</p>
</div>
      </div>
    </section>
  );
}

export default FirstStep;